import React from 'react';
import {Stack, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {Outlet} from 'react-router-dom';

import RoutesTabsComponent from '@components/tabs/RoutesTabs.component';

import {ClientsRoutes} from '@utils/routes.utils';

const ClientsScreen = () => {
  const {t} = useTranslation();

  return (
    <Stack flex={1} width="100%" pt="34px" px="24px" spacing={2}>
      <Typography fontSize="30px" fontWeight="700">
        {t('clients.title')}
      </Typography>
      <Stack flex={1}>
        <RoutesTabsComponent routes={ClientsRoutes.routes()}/>
        <Outlet/>
      </Stack>
    </Stack>
  );
};

export default ClientsScreen;
